import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useCallback,
  useLayoutEffect,
} from 'react'
import Navigation from '../../Components/Navigation'
import RightSetLocationModal from '../../Components/RightSetLocationModal'
import DirectDeliveryModal from 'Components/DirectDeliveryModal/DirectDeliveryModal'
import TableOrdenDeVenta from '../../Components/TableOrdenDeVenta'
import { Row, Col, Container } from 'react-bootstrap'
import { useParams, useHistory } from 'react-router-dom'
import './OrdenDeVenta.css'
import GenericWarningModal from 'Components/GenericWarningModal'
import { useDispatch, useSelector } from 'react-redux'
import { t } from 'i18next'
import { Box, Modal } from '@mui/material'
import FormDireccion from 'Components/FormDireccion'
import {
  fetchCustomerById,
  fetchListWharehouse,
  fetchSearchInfoAddressId,
} from 'redux/actions/clientsActions'
import {
  approvedColumns,
  unaprovedColumns,
  closeColumns,
} from './columnConstants'

import ModalCancelPendingDispatch from 'Components/ModalCancelPendingDispatch'
import { generateSellOrderAction } from 'redux/actions/sellOrderActions'
import GenericModal from 'Components/GenericModal'
import { ID_CONSTANTS } from 'redux/types'
import {
  FormatedDate,
  isCostExemptProduct,
  validateRoles,
  validatorIsCountedCustomer,
  valitadorODCPDF,
  sanitizeOrderNumber,
} from 'Utils/functions'
import { sortLinesWarrantyAfterParent } from 'Utils/sortLinesWarrantyAfterParent'
import {
  documentTypeId,
  salesOrderTypeIds,
  VAPermissions,
  docHeaderStatusDescription,
  salesRoles,
  CUSTOMERID,
  EMPTY_GUID,
} from 'Utils/constants'
import {
  cotizacionUpdate,
  fetchSearchSalesDocumentDetail,
} from 'redux/actions/cotizacionActions'
import MiniLoading from 'Components/MiniLoading'
import RelationalDocLabel from 'Components/RelationalDocLabel'
import { getCorrectQuotationPosition } from './utils/getCorrectDocPosition'
import useValidatePermission from 'Hooks/useValidatePermission'
import { useUploadOdcFile } from './hooks/useUploadOdcFile'
import { DocumentStatusSelector } from './components/DocumentStatusSelector'
import { ModifiedBySection } from './components/ModifiedBySection/indes'
import { PaymentType } from './components/PaymentType'
import { DocumentAddressDetails } from './components/DocumentAddressDetails'
import { EditAddressModal } from './components/EditAddressModal'
import ModalAlertGeneric from 'Components/ModalAlertGeneric/ModalAlertGeneric'
import { getPriceInventoryGeneral } from 'redux/actions/priceProductsAction'
import { Formatter } from 'Utils/Formatter'
import ContentModalProductNegativeMargin from './components/ContentModalProductNegativeMargin'
import { updateProductsAuth } from 'Utils/salesOrdersUtil'
import Tints from 'Hooks/useTintsController/Tints'
import { fetchSummaryTask } from 'redux/actions/tasksActions'
import { approvalSalesOrder } from 'api/mdl11'
import { searchSaleOrderId } from 'api/documentBus'
import { useMarginVisibility } from 'Hooks/useMarginVisibility'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import useHandleWarranty from 'Hooks/Cart/useHandleWarranty'

function OrdenDeVenta(props) {
  const dispatch = useDispatch()
  const param = useParams()
  const { uploadFile } = useUploadOdcFile()
  const { getWarrantyProductText, validateWarrantyDispatch } =
    useHandleWarranty()
  const loginInfo = useSelector(state => state.login?.user?.AuthenticationInfo)
  const hasCustomerServiceRol = validateRoles(
    loginInfo.UserRoles,
    salesRoles.customerService
  )
  const [promisedDate, setPromisedDate] = useState(null)
  const [dataODC, setDataODC] = useState(false)
  const isCustomer = useSelector(state => state.login.isCustomer)
  const [hiddenColumns] = useState([])
  const [comment, setComment] = useState('')
  const [showModal, setShowModal] = useState(false)
  const [isCartEmpty, setIsCartEmpty] = useState(false)
  const [warningText, setWarningText] = useState('')
  const [dispatchQtyState, setDispatchQtyState] = useState([])
  const [costRealTime, setCostRealTime] = useState([])
  const [showAddAddressState, setShowAddAddressState] = useState(false)
  const [addressDetails, setAddressDetails] = useState(null)
  const [isDirectDelivery, setIsDirectDelivery] = useState(false)
  const [directdeliveryState] = useState(false)
  const [listOfNewCosts, setListOfNewCosts] = useState([])
  const [
    openModalCancelPendingDispatchState,
    setOpenModalCancelPendingDispatchState,
  ] = useState(false)
  const sellOrderValidatedRef = useRef(false)
  const addressFetchStateRef = useRef({
    inFlight: false,
    lastFetched: null,
  })
  const [branchesState, setBranchesState] = useState([])
  const [showFailedSellOrderState, setShowFailedSellOrderState] =
    useState(false)
  const [approvedColumnsState, setApprovedColumnsState] = useState(
    approvedColumns({})
  )
  const [unaprovedColumnsState] = useState(unaprovedColumns())
  const [closeColumnsState, setCloseColumnsState] = useState(closeColumns())
  const companyId = useSelector(state => state.company.CompanyId)

  const clienteId = useSelector(
    state => state?.cotizacion?.QuoteHeader?.CustomerId
  )
  const { isCommercialCreditSelected } = useSelector(state => state.sellOrder)
  const [closeWarningModal, setCloseWarningModal] = useState(true)
  const createDispatch = useValidatePermission(VAPermissions.createDispatch)
  const [cancelDispatchProductSelected, setCancelDispatchProductSelected] =
    useState({})
  const useSelectorProducts = useSelector(state => state.cotizacion.QuoteHeader)

  const CompanyId = useSelector(state => state?.company?.CompanyId)
  const warehouse = useSelector(state => state.company.WarehouseId)
  const CompanyCode = useSelector(state => state?.company?.CompanyCode)
  const [hasProductsWithCancel, setHasProductsWithCancel] = useState(false)

  const useSelectorQuoteObject = useSelector(state => state.cotizacion)

  const {
    sellOrderPostLoading,
    sellOrderPostData,
    isRedirect,
    sellOrderFileAttached,
  } = useSelector(state => state.sellOrder)

  const canChangePriceODV = useValidatePermission(
    VAPermissions.priceOverrideAuthODV
  )

  const [isErrorAddressModal, setIsErrorAddressModal] = useState(false)
  const [messageAddressModal, setMessageAddressModal] = useState({
    message: '',
    status: '',
  })

  const isCountedCustomer = validatorIsCountedCustomer(
    useSelectorQuoteObject?.QuoteHeader
  )

  const customerSavedLocations = useSelector(
    state => state.sellOrder.customerInfoObject
  )

  const linesFulfillmentPlan = (useSelectorProducts.Lines || [])
    .filter(item => item.FulfillmentPlanId)
    .map(line => line.FulfillmentPlanId)

  const fulfillmentPlanIdSelected =
    linesFulfillmentPlan.length > 0 ? linesFulfillmentPlan[0] : null

  const detectMethodFromSelectedAddress = selectedAddress => {
    const isHome =
      selectedAddress?.AddressInfo || selectedAddress?.Address_AddressId
    const isBranch =
      selectedAddress?.WarehouseId || selectedAddress?.WarehouseDescription

    if (isHome) return 'DEL'
    if (isBranch) return 'BRANCH'
    return 'DEL'
  }

  const viewProductMargin = useValidatePermission(VAPermissions.seeMargenProd)
  const lines =
    sellOrderPostData?.Data?.SalesDocumentInfo?.Lines ||
    useSelectorProducts.Lines ||
    []

  const { showAll, toggleAll, toggleRow, isRowVisible } = useMarginVisibility(
    lines.length
  )

  const getPrices = async PriceInventoryPayload => {
    try {
      const response = await dispatch(
        getPriceInventoryGeneral(PriceInventoryPayload)
      )
      return response?.data?.Data
    } catch (error) {
      console.error(error)
    }
  }

  const fetchPriceInventory = async dispatchQtyState => {
    try {
      const PriceInventoryData = {
        CompanyId,
        CompanyCode,
        WarehouseId: warehouse,
        ProductIds: dispatchQtyState
          .filter(
            item => item?.WarrantyProductId == null && !item?.IsExtendedWarranty
          )
          .map(item => item?.ProductId || item?.productId),
        UoMId: null,
      }

      const priceData = await getPrices(PriceInventoryData)
      setCostRealTime(priceData)
      return priceData
    } catch (error) {
      console.error('Error fetching price inventory:', error)
      throw error
    }
  }

  const getSkusNoCostProduct = () => {
    const inactiveCodes = prodWithNoCost.map(product => product.referencia)
    const skusProd = inactiveCodes.join(', ')
    return skusProd
  }

  useEffect(() => {
    if (useSelectorQuoteObject?.QuoteHeader?.PromisedDate) {
      setPromisedDate(useSelectorQuoteObject.QuoteHeader?.PromisedDate)
    }
  }, [useSelectorQuoteObject?.QuoteHeader?.PromisedDate])

  const hasCreditCommercial =
    param?.isPreorderValidatedOnRoute === 'created' &&
    sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountNumber

  const [webOdvDetails, setWebOdvDetails] = useState([])
  const isPreOrder = window.location.pathname.includes('preorden_de_venta')
  const isWebDocument =
    sellOrderPostData?.Data?.SalesDocumentInfo?.Origin === 'AB'
  const isHomeDelivery = webOdvDetails?.DeliveryType === 1
  const showHomeDeliveryAddress = isWebDocument
    ? isHomeDelivery
    : useSelectorProducts?.QuoteAddressId

  const history = useHistory()
  const preOrderTable = window.location.pathname.includes('preorden_de_venta')
  const sellOrderValidated = useSelector(
    state => state.sellOrder.isPreOrderValidated
  )
  const { user } = useSelector(state => state.login)
  const [loadingData, setLoadingData] = useState(
    () => !!(param?.id && !isRedirect)
  )
  const [isApproved, setIsApproved] = useState(true)
  const [odvStatus, setOdvStatus] = useState(false)
  const [productsData, setProductsData] = useState([])

  sellOrderValidatedRef.current = sellOrderValidated

  const validateDirectDeliveryProviders = lineItem => {
    let validationPassed = false

    lineItem?.Providers?.forEach(itemProv => {
      if (itemProv.IsDirectDelivery) {
        validationPassed = true
      }
    })
    return validationPassed
  }

  const validateHasProductsWithCancel = () => {
    let validationPassed = false
    dispatchQtyState.forEach(item => {
      if (item.qtyCanceled > 0) {
        validationPassed = true
      }
    })
    return validationPassed
  }

  const productsActives = () => {
    const validationStatus = dispatchQtyState.some(
      item => item.IsActive === false
    )
    return validationStatus
  }

  const getInactiveProductCodes = () => {
    const inactiveCodes = dispatchQtyState
      .filter(product => !product.IsActive)
      .map(product => product.referencia)

    const skusProd = inactiveCodes.join(', ')
    return skusProd
  }

  const setTableData = async (data, status) => {
    if (!data) return []

    let externalProducts = []
    if (isPreOrder) {
      setLoadingData(true)
      try {
        const products = await fetchPriceInventory(data)
        if (products) {
          externalProducts = products
        }
      } catch (error) {
        console.error(error)
      } finally {
        setLoadingData(false)
      }
    }

    const products = data?.map((product, index) => {
      const productData =
        sellOrderPostData?.Data?.SalesDocumentInfo?.Lines.find(
          line => line.DocLineId === product.DocLineId
        ) ??
        sellOrderPostData?.Data?.SalesDocumentInfo?.Lines.find(
          line => line.ProductId === product.ProductId
        )
      const qtyCanceled = product?.QtyCanceled || 0
      const qtyDelivered = product?.QtyDelivered

      const isProductApproved = Boolean(
        product?.AuthorizedPriceBy &&
          product?.AuthorizedPriceByName &&
          product.Price < product.FinalPrice &&
          product?.Cost > product?.Price
      )

      const externalProduct = externalProducts.find(
        line => line.ProductId === product.ProductId
      )

      return {
        ...product,
        allowFractionalQty: product?.AllowFractionalQty,
        productId: product?.ProductId,
        referencia: product?.SystemCode,
        descripción: (
          <>
            <span>{getWarrantyProductText(product).replace('\n', ' - ')}</span>
            {product?.ColorVariants && !product?.IsExtendedWarranty && (
              <Tints
                key={product?.ProductId}
                tints={product?.ColorVariants}
                productId={product?.ProductId}
              />
            )}
          </>
        ),
        qtyPending: product?.PendingQuantity,
        qtyReturned: product?.QtyReturned,
        pendingQuantity: product?.PendingQuantity,
        status,
        cantidad: product?.Quantity,
        precio_unitario: product?.Price,
        Descuento: product?.DiscountAmount,
        precio_total: product?.Price * product?.Quantity,
        costo: product?.Cost ? product?.Cost : 0.0,
        costModifier: !!(
          product?.Cost === 0 ||
          product?.Cost?.toFixed(2) === null ||
          product?.Cost?.toFixed(2) === undefined
        ),
        solicitud_despacho: null,
        negativeMargen: isWebDocument
          ? false
          : product?.Price < product?.FinalPrice &&
            product?.Cost > product?.Price,
        isApproved: isProductApproved,
        isSupplierDirectDelivery: validateDirectDeliveryProviders(product),
        reasonId: productData?.ReasonId || null,
        IsActive: externalProduct
          ? externalProduct.IsActive
          : product?.IsActive,
        qtyCanceled,
        qtyDelivered,
        qtyOutstanding: productData?.QtyOutstanding || 0,
        IsService: product?.IsService,
        quantityInvoiced: product?.QuantityInvoiced,
      }
    })
    return products
  }

  const [hasProdWithNoCost, setHasProdWithNoCost] = useState(false)

  const prodWithNoCost = useMemo(() => {
    const products = preOrderTable ? productsData : dispatchQtyState

    const productWithNoCostMapped = products.map((item, index) => {
      const product = costRealTime?.find(
        prod => prod?.ProductId === item?.productId
      )

      const newCost = product?.Cost || product?.AvgCost

      return {
        ...item,
        costoRealTime: newCost || 0,
      }
    })

    setHasProdWithNoCost(
      productWithNoCostMapped?.some(
        item =>
          !item.IsService &&
          !isCostExemptProduct(item) &&
          item.costoRealTime === 0
      )
    )

    return productWithNoCostMapped?.filter(
      item =>
        !item.IsService &&
        !isCostExemptProduct(item) &&
        item.costoRealTime === 0
    )
  }, [costRealTime, productsData, dispatchQtyState])

  const saveChangeCancelDispatch = async (
    productId,
    reasonId,
    docLineId = null
  ) => {
    setLoadingData(true)
    try {
      const lines = sellOrderPostData?.Data?.SalesDocumentInfo?.Lines ?? []

      const targetDispatchItem = docLineId
        ? dispatchQtyState.find(item => item.DocLineId === docLineId)
        : dispatchQtyState.find(item => item.productId === productId)

      const rawQtyCanceled =
        targetDispatchItem?.solicitud_despacho ||
        Number(targetDispatchItem?.pendingQuantity) ||
        1

      const qtyCanceled = Number.isInteger(rawQtyCanceled)
        ? rawQtyCanceled
        : Number(Formatter.Money(rawQtyCanceled, { withFormat: false }))

      const cancelingWarranty = lines.some(
        line => line.ProductId === productId && line.WarrantyProductId !== null
      )

      let newLines
      if (cancelingWarranty) {
        // Cancelación directa de garantía: usa DocLineId para identificar la línea exacta
        newLines = lines.map(line => {
          line.salesOrderLineId = line.DocLineId
          line.salesOrderHeaderId = line.DocHeaderId

          const isTargetLine = docLineId
            ? line.DocLineId === docLineId
            : line.ProductId === productId && line.WarrantyProductId !== null

          if (isTargetLine) {
            line.QtyCanceled = Math.min(
              (line.QtyCanceled ?? 0) + qtyCanceled,
              line.Quantity
            )
            line.ReasonId = reasonId
          }

          return line
        })
      } else {
        // Cancelación de producto: ajustar garantía si qty_garantia > qty_producto resultante
        const productLine = lines.find(
          line =>
            line.ProductId === productId && line.WarrantyProductId === null
        )
        const totalQuantityCanceled = Math.min(
          (productLine?.QtyCanceled ?? 0) + qtyCanceled,
          productLine?.Quantity ?? qtyCanceled
        )

        const isWarrantyOfProduct = line => line.WarrantyProductId === productId

        let warrantyLine = lines.find(isWarrantyOfProduct)

        // Fallback: ODV created before warrantyProductId was populated in the payload.
        // Use the quote lines to resolve the warranty's ProductId, then match by ProductId.
        if (!warrantyLine) {
          const quoteLines = useSelectorQuoteObject?.QuoteHeader?.Lines ?? []
          const warrantyQuoteLine = quoteLines.find(
            l => l.WarrantyProductId === productId
          )
          if (warrantyQuoteLine) {
            warrantyLine = lines.find(
              l => l.ProductId === warrantyQuoteLine.ProductId
            )
          }
        }

        const newProductEffectiveQty =
          (productLine?.Quantity ?? 0) - totalQuantityCanceled
        const warrantyEffectiveQty = warrantyLine
          ? (warrantyLine.Quantity ?? 0) - (warrantyLine.QtyCanceled ?? 0)
          : 0
        const warrantyCancelQty = Math.max(
          0,
          warrantyEffectiveQty - newProductEffectiveQty
        )

        newLines = lines.map(line => {
          line.salesOrderLineId = line.DocLineId
          line.salesOrderHeaderId = line.DocHeaderId

          if (line.ProductId === productId && line.WarrantyProductId === null) {
            line.QtyCanceled = totalQuantityCanceled
            line.ReasonId = reasonId
          } else if (isWarrantyOfProduct(line) && warrantyCancelQty > 0) {
            line.QtyCanceled = Math.min(
              (line.QtyCanceled ?? 0) + warrantyCancelQty,
              line.Quantity
            )
            line.ReasonId = reasonId
          }

          return line
        })
      }

      const payload = {
        documentTypeId:
          sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentTypeId,
        salesOrder: {
          salesOrderHeaderId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId,
          customerId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.CustomerId ||
            CUSTOMERID,
          creditAccountId: null,
          salesAgentId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.SalesAgentId,
          DocumentDate:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentDate,
          quantity: sellOrderPostData?.Data?.SalesDocumentInfo?.Quantity,
          amount: sellOrderPostData?.Data?.SalesDocumentInfo?.Amount,
          amountWithTax:
            sellOrderPostData?.Data?.SalesDocumentInfo?.AmountWithTax,
          taxAmount: sellOrderPostData?.Data?.SalesDocumentInfo?.TaxAmount,
          companyId: sellOrderPostData?.Data?.SalesDocumentInfo?.CompanyId,
          companyCode: sellOrderPostData?.Data?.SalesDocumentInfo?.CompanyCode,
          quoteHeaderId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.QuoteHeaderId,
          salesOrderTypeId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.SalesOrderTypeId,
          HeaderStatusId:
            sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderStatusId,
          comments: sellOrderPostData?.Data?.SalesDocumentInfo?.Comments,
          salesAgentEmail:
            sellOrderPostData?.Data?.SalesDocumentInfo?.SalesAgentEmail,
          WarehouseId: sellOrderPostData?.Data?.SalesDocumentInfo?.WarehouseId,
          origin: sellOrderPostData?.Data?.SalesDocumentInfo?.Origin,
          lines: newLines,
        },
      }
      await dispatch(generateSellOrderAction(payload))
    } catch (error) {
      console.error(error)
    } finally {
      window.location.reload()
    }
  }

  const fetchWarehouse = async CreditAccountId => {
    const payload = {
      tenantId: 2,
      SearchText: null,
      PageNumber: 1,
      PageSize: 100,
      ...(CreditAccountId && {
        companyId,
      }),
    }
    const warehouseInfo = await dispatch(fetchListWharehouse(payload))
    const warehouses = warehouseInfo
      .map(branch => {
        const composedWarehouse = {
          ...branch.Warehouses[0],
          WarehouseAddress: branch.Address_AddressDetail,
          AddressId: branch.AddressId,
        }
        return composedWarehouse
      })
      .filter(warehouse => {
        return warehouse.Description !== undefined
      })
      .sort((a, b) => {
        const targetCompanyId = companyId

        const aMatch = a.CompanyId === targetCompanyId
        const bMatch = b.CompanyId === targetCompanyId

        if (aMatch && !bMatch) return -1
        if (!aMatch && bMatch) return 1

        return a.Description.localeCompare(b.Description)
      })
    setBranchesState(prevState => [...prevState, ...warehouses])
  }

  const updatCustomer = async CustomerId => {
    const response = await dispatch(fetchCustomerById(CustomerId))
    dispatch({ type: 'SET_CUSTOMER_INFO', payload: response })
  }

  const fetchTasks = async (docNumber, origin) => {
    if (origin === 'AB') return
    const payload = {
      Type: 'SALE_ORDER',
      StatusId: '4083C912-7FCA-47AA-B65B-005256AC782C',
      SalesAgentId: user.AuthenticationInfo.UserId,
      WarehouseId: null,
      SearchText: docNumber,
      AppType: null,
      PageSize: 16,
      PageNumber: 1,
    }

    const response = await dispatch(fetchSummaryTask(payload))
    const status = response.data?.Data?.some(
      status => status.StatusDescription === 'Pendiente'
    )
    if (response && response.data?.Data.length > 0) {
      if (status) {
        setOdvStatus(true)
      } else {
        setOdvStatus(false)
        console.error('Error:', response.toString())
      }
    }
  }

  const odvProducts = sellOrderPostData?.Data?.SalesDocumentInfo?.Lines
  const hasProductsDiscount = odvProducts?.filter(
    product => product?.NegotiatedPriceBy && product?.NegotiatedPriceByName
  )

  const hasChangePriceApprove =
    hasProductsDiscount?.length > 0
      ? hasProductsDiscount?.every(
          product =>
            product?.AuthorizedPriceBy &&
            product?.AuthorizedPriceByName &&
            product.Price < product.FinalPrice
        )
      : false

  const fetchDocument = async (
    DocumentTypeId = null,
    id = null,
    header = null
  ) => {
    const requestedAt = Date.now()
    setLoadingData(true)
    try {
      const payload = {
        DocumentTypeId,
        DocumentHeaderId: id,
        DocumentNumber: header,
        PageNumber: 1,
        PageSize: 1,
      }
      const { Data, Status } = await dispatch(
        fetchSearchSalesDocumentDetail(payload)
      )
      const isODV =
        DocumentTypeId.toLowerCase() === documentTypeId.ODV.toLowerCase()
      if (Data && Status.Code === 200) {
        if (isODV) {
          const dataFormated = { Data: { SalesDocumentInfo: { ...Data } } }
          dispatch({ type: 'SELL_ORDER_POST_RESULT', payload: dataFormated })
          await fetchTasks(
            dataFormated.Data?.SalesDocumentInfo?.DocumentNumber,
            dataFormated.Data?.SalesDocumentInfo?.Origin
          )
          const relationalDocPosition =
            getCorrectQuotationPosition(Data?.RelationDoc) ?? 0
          const { DocHeaderId, DocumentNumber, DocumentTypeId } =
            Data?.RelationDoc?.[relationalDocPosition]
          await fetchDocument(DocumentTypeId, DocHeaderId, DocumentNumber)
        } else {
          await fetchPriceInventory(Data?.Lines)
        }
        const hasODC = Data?.RelationDoc.find(
          doc => doc.DocumentTypeId === documentTypeId.ODC
        )
        if (hasODC && isODV) {
          const response = await valitadorODCPDF(Data)
          setDataODC(response)
        }
        if (
          DocumentTypeId.toLowerCase() ===
          documentTypeId.QUOTATION.toLowerCase()
        ) {
          dispatch(
            cotizacionUpdate({
              data: Data,
              QuoteHeaderId: id,
              requestedAt,
            })
          )
          const customerId =
            sellOrderPostData?.Data?.SalesDocumentInfo?.CustomerId
          const isCountedCustomer = validatorIsCountedCustomer(customerId)

          if (isCountedCustomer) {
            return
          }
          updatCustomer(Data.CustomerId)
        }
      }
      isODV && fetchWarehouse(Data?.CreditAccountId)
    } catch (error) {
      console.error(error)
    } finally {
      setLoadingData(false)
    }
  }

  const normalizeId = useCallback(id => {
    return id ? String(id).toUpperCase().trim() : null
  }, [])

  // Mantiene el AddressId más reciente para descartar respuestas viejas (race conditions)
  const latestAddressIdRef = useRef(null)
  const pendingAddressIdRef = useRef(null)

  const currentQuoteAddressId =
    useSelectorQuoteObject?.QuoteHeader?.Address_AddressId || null
  latestAddressIdRef.current = currentQuoteAddressId

  const fetchAddressId = useCallback(
    async requestedAddressId => {
      if (!requestedAddressId) return

      const normalizedRequested = normalizeId(requestedAddressId)

      try {
        const response = await dispatch(
          fetchSearchInfoAddressId(requestedAddressId)
        )

        // Si mientras esperábamos el AddressId cambió, descartamos esta respuesta
        const currentNormalized = normalizeId(latestAddressIdRef.current)
        if (currentNormalized !== normalizedRequested) return

        if (!response?.length) return
        const newAddressInfo = response[0]

        // Para counted customer: SOLO la dirección actual (evita mostrar anterior + nueva)
        if (isCountedCustomer) {
          dispatch({
            type: 'SET_CUSTOMER_INFO',
            payload: { AddressList: [{ AddressInfo: newAddressInfo }] },
          })
          return
        }

        // Para otros clientes: mantener lista, evitando duplicados
        const prevList = customerSavedLocations?.AddressList || []
        const normalizedNew = normalizeId(
          newAddressInfo?.AddressId || newAddressInfo?.Address_AddressId
        )

        const nextList = prevList
          .filter(item => {
            const itemNormalized = normalizeId(
              item?.AddressInfo?.AddressId ||
                item?.AddressInfo?.Address_AddressId
            )
            return itemNormalized !== normalizedNew
          })
          .concat([{ AddressInfo: newAddressInfo }])

        dispatch({
          type: 'SET_CUSTOMER_INFO',
          payload: { AddressList: nextList },
        })
      } finally {
        // Permite ejecutar el siguiente fetch pendiente
        addressFetchStateRef.current.inFlight = false

        // Si el AddressId cambió mientras estábamos en vuelo, disparamos el más reciente
        const pending = pendingAddressIdRef.current
        if (pending) {
          pendingAddressIdRef.current = null
          const normalizedPending = normalizeId(pending)
          const normalizedRequested = normalizeId(requestedAddressId)

          if (normalizedPending !== normalizedRequested) {
            addressFetchStateRef.current.inFlight = true
            addressFetchStateRef.current.lastFetched = pending
            // Disparo inmediato sin depender de re-render
            fetchAddressId(pending)
          }
        }
      }
    },
    [
      dispatch,
      isCountedCustomer,
      customerSavedLocations?.AddressList,
      normalizeId,
    ]
  )

  useLayoutEffect(() => {
    const isCreatedOrder =
      sellOrderValidated && param?.isPreorderValidatedOnRoute === 'created'
    if (isCreatedOrder) {
      dispatch({ type: 'CLEAN_SELL_ORDER', payload: null })
    }
  }, [])

  // ============================================================
  // useEffect UNIFICADO (ejecuta fetch solo si falta el AddressId actual)
  // ============================================================

  useEffect(() => {
    const currentAddressId = currentQuoteAddressId
    if (!currentAddressId) return
    if (!isCountedCustomer) return
    if (!sellOrderPostData) return

    const normalizedCurrent = normalizeId(currentAddressId)
    const { inFlight, lastFetched } = addressFetchStateRef.current
    const normalizedLastFetched = normalizeId(lastFetched)

    const list = customerSavedLocations?.AddressList || []

    // Counted customer: si por algún motivo se acumuló más de una, limpiar
    if (list.length > 1) {
      const filtered = list.filter(item => {
        const itemNormalized = normalizeId(
          item?.AddressInfo?.AddressId || item?.AddressInfo?.Address_AddressId
        )
        return itemNormalized === normalizedCurrent
      })
      if (filtered.length !== list.length) {
        dispatch({
          type: 'SET_CUSTOMER_INFO',
          payload: { AddressList: filtered },
        })
      }
    }

    const hasCurrentId = list.some(item => {
      const itemNormalized = normalizeId(
        item?.AddressInfo?.AddressId || item?.AddressInfo?.Address_AddressId
      )
      return itemNormalized === normalizedCurrent
    })

    // Si ya tenemos el id en lista, no hacer nada
    if (hasCurrentId) return

    // Si hay fetch en vuelo, marcamos el pending y salimos
    if (inFlight) {
      pendingAddressIdRef.current = currentAddressId
      return
    }

    // Si ya pedimos este mismo id, no repetir
    if (normalizedLastFetched === normalizedCurrent) return

    addressFetchStateRef.current.inFlight = true
    addressFetchStateRef.current.lastFetched = currentAddressId
    fetchAddressId(currentAddressId)
  }, [
    currentQuoteAddressId,
    customerSavedLocations?.AddressList,
    isCountedCustomer,
    normalizeId,
    dispatch,
    fetchAddressId,
  ])

  const validatePreorderInfo = () => {
    sellOrderValidatedRef.current = true
    dispatch({
      type: 'SET_PREORDER_VALIDATION',
      payload: true,
    })
  }

  useEffect(() => {
    const init = async () => {
      const dataCommercialCredit = isCommercialCreditSelected
      dispatch({
        type: 'IS_COMMERCIAL_CREDIT_SELECTED',
        payload: dataCommercialCredit,
      })

      validatePreorderInfo()
      if (param?.id && !isRedirect) {
        dispatch({ type: 'SET_CUSTOMER_INFO', payload: null })
        fetchDocument(documentTypeId.ODV, param?.id)
      }

      dispatch({ type: 'SET_IS_REDIRECT', payload: false })
    }
    init()
  }, [])

  useEffect(() => {
    if (sellOrderPostData?.Data?.SalesDocumentInfo?.Lines) {
      setHasProductsWithCancel(validateHasProductsWithCancel())
    }
  }, [dispatchQtyState])

  const hasQuantityInvoiced = useMemo(() => {
    return productsData?.some(item => Number(item?.quantityInvoiced ?? 0) > 0)
  }, [productsData])

  useEffect(() => {
    setApprovedColumnsState(
      approvedColumns({
        hasProductsWithCancel,
        isCustomer,
        hasQuantityInvoiced,
        viewProductMargin,
        showAll,
        toggleAll,
        toggleRow,
        isRowVisible,
      })
    )

    setCloseColumnsState(
      closeColumns(hasProductsWithCancel, hasQuantityInvoiced)
    )
  }, [
    hasProductsWithCancel,
    sellOrderPostData?.Data?.SalesDocumentInfo?.DescriptionStatus,
    hasQuantityInvoiced,
    viewProductMargin,
    showAll,
    isRowVisible,
  ])

  useEffect(() => {
    const fetchData = async () => {
      const lines =
        sellOrderPostData?.Data?.SalesDocumentInfo?.Lines ||
        useSelectorProducts.Lines
      const status =
        sellOrderPostData?.Data?.SalesDocumentInfo?.DescriptionStatus ||
        useSelectorProducts.DescriptionStatus
      if (lines) {
        const data = await setTableData(lines, status)
        setProductsData(data)
      }
    }

    fetchData()
  }, [useSelectorProducts, sellOrderPostData])

  useEffect(() => {
    if (productsData.length > 0) {
      dispatch({ type: 'SELL_ORDER_POST_LOADING', payload: false })
      dispatch({ type: 'DISPATCH_ORDER_POST_LOADING', payload: false })

      const setProductValidation = productsData.map(item => {
        const qtyDelivered = parseFloat(item?.qtyDelivered || 0)
        const qtyCanceled = parseFloat(item?.qtyCanceled || 0)

        const pendientResult = parseFloat(item?.qtyPending || 0)
        const returnedResult = parseFloat(item?.qtyReturned || 0)

        const qtyPending = Formatter.Money(pendientResult, {
          decimalPrecision: 2,
          ignoreDecimal: !item?.allowFractionalQty,
          withFormat: false,
        })
        const qtyReturned = Formatter.Money(returnedResult, {
          decimalPrecision: 2,
          ignoreDecimal: !item?.allowFractionalQty,
          withFormat: false,
        })

        const product = costRealTime?.find(
          prod => prod?.ProductId === item?.productId
        )
        const newCost = product?.Cost || product?.AvgCost
        const needAprovePrice = !item.isApproved && item?.negativeMargen
        const isDisabled =
          needAprovePrice ||
          !item.IsActive ||
          isCustomer ||
          (!item.IsService &&
            !item.IsExtendedWarranty &&
            !isCostExemptProduct(item) &&
            newCost === 0) ||
          !(item?.pendingQuantity > 0)

        return {
          ...item,
          qtyDelivered,
          qtyReturned,
          qtyCanceled,
          isSelected: false,
          isDisabled,
          solicitud_despacho: '',
          qtyPending,
          cancelados: item?.qtyCanceled || null,
          costo: newCost || 0,
        }
      })

      setDispatchQtyState(sortLinesWarrantyAfterParent(setProductValidation))
      setComment(sellOrderPostData?.Data?.SalesDocumentInfo?.Comments)
    }
  }, [productsData])

  const location = window.location.href

  const allProductsWithNegativeMargin = useMemo(
    () =>
      useSelectorQuoteObject?.QuoteHeader?.Lines?.filter(
        line =>
          line?.Price <
            (line?.FinalPrices?.[1]?.FinalPrice || line?.FinalPrice) &&
          line?.NegotiatedReasonId !== null
      ),
    [useSelectorQuoteObject?.QuoteHeader?.Lines, location]
  )
  const productsWithNegativeMargin = useMemo(
    () =>
      allProductsWithNegativeMargin?.filter(line => {
        const product = productsData?.find(
          product => product?.productId === line?.ProductId
        )
        if (
          line?.AuthorizedPriceBy?.length &&
          line?.AuthorizedPriceByName?.length
        ) {
          return false
        }
        if (
          product?.cantidad - product?.qtyDelivered - product?.qtyCanceled >
          0
        ) {
          return true
        }
        return false
      }),
    [allProductsWithNegativeMargin]
  )
  const createOrder = useValidatePermission(VAPermissions.createOrder)

  useEffect(() => {
    const checkApprovalState = async () => {
      try {
        const data = await approvalSalesOrder(
          useSelectorQuoteObject?.QuoteHeader?.RelationDoc?.find(
            doc =>
              doc?.DocumentNumber.includes('ODV') ||
              doc?.DocumentTypeId?.toLowerCase().includes(
                documentTypeId?.ODV?.toLowerCase()
              )
          )?.DocHeaderId
        )
        setIsApproved(data?.data?.Data?.[0]?.Approval)
      } catch (error) {
        setIsApproved(true)
      }
    }
    if (
      productsWithNegativeMargin?.length > 0 &&
      location.includes('created')
    ) {
      checkApprovalState()
    }
  }, [productsWithNegativeMargin, location])

  const validateCheckedProduct = () => {
    let validateProductIsSelected = false

    dispatchQtyState.every(item => {
      const quantityDispatch =
        typeof item.solicitud_despacho === 'string'
          ? Number(item.solicitud_despacho.replace(/,/g, ''))
          : item.solicitud_despacho

      if (
        item.isSelected === true &&
        quantityDispatch <= item.cantidad &&
        quantityDispatch > 0
      ) {
        validateProductIsSelected = true
        return true
      } else {
        if (
          item.isSelected === true &&
          !(quantityDispatch <= item.cantidad && quantityDispatch > 0)
        ) {
          validateProductIsSelected = false
          return false
        } else {
          return true
        }
      }
    })

    return validateProductIsSelected
  }

  const getArrayHiddenColumns = hiddenColumns => {
    const hiddenColumnsCopy = hiddenColumns.filter(column =>
      column.Status === false ? column.ColumnName : false
    )
    return hiddenColumnsCopy.map(column => column.ColumnName)
  }
  const buttonChange =
    sellOrderValidated && param?.isPreorderValidatedOnRoute === 'created'
      ? createDispatch
      : createOrder

  const buttonValidator =
    sellOrderValidated && param?.isPreorderValidatedOnRoute === 'created'
      ? dispatchQtyState.some(p => Number(p.pendingQuantity))
      : true

  const columns = useMemo(() => {
    const productsPending = dispatchQtyState.filter(
      p => p.qtyDelivered !== p.cantidad
    )

    if (sellOrderValidated && param?.isPreorderValidatedOnRoute === 'created') {
      if (!productsPending?.length) {
        return closeColumnsState
      }
      return approvedColumnsState
    } else {
      return unaprovedColumnsState
    }
  }, [
    sellOrderValidated,
    approvedColumnsState,
    unaprovedColumnsState,
    hasProductsWithCancel,
    dispatchQtyState,
  ])

  const handleOpen = state => {
    setShowModal(state)
  }

  const fetchCustomerOnUpdate = async () => {
    if (!isCountedCustomer) {
      const customerData = await dispatch(fetchCustomerById(clienteId))
      if (customerData) {
        dispatch({ type: 'SET_CUSTOMER_INFO', payload: customerData })
        setShowAddAddressState(false)
      }
    } else {
      setShowAddAddressState(false)
    }
  }

  const buildWarrantyDispatchLine = (
    productItem,
    quantityDispatch,
    valueProducts,
    dispatchedLines
  ) => {
    if (productItem.IsExtendedWarranty || productItem.WarrantyProductId)
      return null

    const warrantyItem = valueProducts.find(
      item =>
        item.WarrantyProductId === productItem.productId &&
        Number(item.pendingQuantity) > 0
    )
    if (!warrantyItem) return null

    // If the warranty row is selected it will be added by the main loop — skip auto-add
    if (warrantyItem.isSelected) return null

    const alreadyAdded = dispatchedLines.some(
      line => line.WarrantyProductId === productItem.productId
    )
    if (alreadyAdded) return null

    const odvLines =
      sellOrderPostData?.Data?.SalesDocumentInfo?.Lines ||
      useSelectorProducts.Lines ||
      []
    const warrantyLine = odvLines.find(
      line => line.WarrantyProductId === productItem.productId
    )
    if (!warrantyLine) return null

    const warrantyQty = Math.min(
      quantityDispatch,
      Number(warrantyItem.pendingQuantity)
    )
    return {
      sellOrderTableValues: {
        ...warrantyItem,
        solicitud_despacho: warrantyQty,
      },
      ...warrantyLine,
    }
  }

  const validateSelectedProductsToDispatch = valueProducts => {
    const arrayOfSelectedProducts = {
      ...useSelectorProducts,
      comment,
      Lines: [],
    }

    const odvLines =
      sellOrderPostData?.Data?.SalesDocumentInfo?.Lines ||
      useSelectorProducts.Lines ||
      []
    let availableLines = [...odvLines]

    valueProducts.forEach(productItem => {
      const quantityDispatch =
        typeof productItem.solicitud_despacho === 'string'
          ? Number(productItem.solicitud_despacho.replaceAll(',', ''))
          : productItem.solicitud_despacho

      if (
        productItem.isSelected === true &&
        quantityDispatch <= productItem.cantidad &&
        quantityDispatch > 0
      ) {
        let currentLine = productItem.DocLineId
          ? availableLines.find(
              line => line.DocLineId === productItem.DocLineId
            )
          : null

        if (!currentLine) {
          currentLine = availableLines.find(line => {
            const productIdMatch =
              line.ProductId?.toLowerCase() ===
              productItem.productId?.toLowerCase()
            if (productItem.WarrantyProductId) {
              return (
                productIdMatch &&
                line.WarrantyProductId === productItem.WarrantyProductId
              )
            }
            return productIdMatch
          })
        }

        if (currentLine) {
          availableLines = availableLines.filter(l => l !== currentLine)
        }

        arrayOfSelectedProducts.Lines.push({
          sellOrderTableValues: productItem,
          ...currentLine,
        })

        const warrantyLine = buildWarrantyDispatchLine(
          productItem,
          quantityDispatch,
          valueProducts,
          arrayOfSelectedProducts.Lines
        )
        if (warrantyLine) arrayOfSelectedProducts.Lines.push(warrantyLine)
      }
    })
    return arrayOfSelectedProducts
  }

  const validateOrderInfo = () => {
    const { isValid, warningText: warrantyWarning } =
      validateWarrantyDispatch(dispatchQtyState)
    if (!isValid) {
      setWarningText(warrantyWarning)
      setIsCartEmpty(true)
      return
    }
    if (validateCheckedProduct()) {
      setShowModal(!showModal)
      dispatch({
        type: 'SET_SELL_ORDER_OBJECT',
        payload: validateSelectedProductsToDispatch(dispatchQtyState),
      })
    } else {
      setWarningText(t('SELL_ORDER_T.GENERIC_TEXT_WARNING'))
      setIsCartEmpty(true)
    }
  }

  const onValidateOrderModals = () => {
    return (
      <>
        {showAddAddressState ? (
          <Modal
            sx={{
              display: 'flex',
              justifyContent: 'center',
              width: window.innerWidth - 491,
              alignItems: 'center',
              zIndex: 9999,
            }}
            onClose={() => {
              setShowAddAddressState(false)
            }}
            open={showAddAddressState}>
            <>
              <FormDireccion
                setSelectedAddress={() => {}}
                setDireccion={() => {}}
                isModalScreen={true}
                handleMetodoEntrega={fetchCustomerOnUpdate}
                setIsErrorAddressModal={setIsErrorAddressModal}
                setMessageAddressModal={setMessageAddressModal}
              />
            </>
          </Modal>
        ) : null}
        {!!addressDetails && (
          <EditAddressModal
            onClose={() => setAddressDetails(null)}
            onSave={fetchCustomerOnUpdate}
            addressDetails={addressDetails}
            setIsErrorAddressModal={setIsErrorAddressModal}
            setMessageAddressModal={setMessageAddressModal}
          />
        )}
        {isErrorAddressModal && (
          <ModalAlertGeneric
            isError={isErrorAddressModal}
            setIsError={setIsErrorAddressModal}
            messageSettings={messageAddressModal}
            setMessageSettings={setMessageAddressModal}
          />
        )}
        {showModal && (
          <div className="moda-background">
            <DirectDeliveryModal
              data={dispatchQtyState}
              isDirectDelivery={isDirectDelivery}
              setListOfNewCosts={setListOfNewCosts}
              listOfNewCosts={listOfNewCosts}
            />
            <RightSetLocationModal
              branchesData={branchesState}
              handleOpen={handleOpen}
              open={showModal}
              deployAddAddres={deployedValue => {
                setShowAddAddressState(deployedValue)
              }}
              showEditAddress={details => {
                setAddressDetails(details)
              }}
              data={dispatchQtyState}
              isDirectDelivery={isDirectDelivery}
              setIsDirectDelivery={setIsDirectDelivery}
              listOfNewCosts={listOfNewCosts}
              webOdvDetails={webOdvDetails}
              promisedDate={promisedDate}
              setPromisedDate={setPromisedDate}
              comments={comment}
              fulfillmentPlanIdSelected={fulfillmentPlanIdSelected}
              deliveryMethodODV={detectMethodFromSelectedAddress(
                useSelectorProducts
              )}
            />
          </div>
        )}

        <GenericWarningModal
          validateIsCartEmpty={isCartEmpty}
          setValidateIsCartEmpty={setIsCartEmpty}
          textSelected={warningText || t('SELL_ORDER_T.GENERIC_TEXT_WARNING')}
        />
        <ModalCancelPendingDispatch
          openModalCancelPendingDispatchState={
            openModalCancelPendingDispatchState
          }
          setOpenModalCancelPendingDispatchState={
            setOpenModalCancelPendingDispatchState
          }
          processCancelDispatch={value => {
            setOpenModalCancelPendingDispatchState(value)
          }}
          setCancelDispatchProductSelected={value =>
            setCancelDispatchProductSelected(value)
          }
          saveCancelDispatch={reasonId =>
            saveChangeCancelDispatch(
              cancelDispatchProductSelected.productId,
              reasonId,
              cancelDispatchProductSelected.DocLineId ?? null
            )
          }
        />
      </>
    )
  }

  const hasProdsActives = useSelectorQuoteObject?.QuoteHeader?.Lines.some(
    product => product.IsActive
  )

  const populateItemsArrayOfPayload = () => {
    const arrayOfItems = []
    useSelectorQuoteObject?.QuoteHeader?.Lines.forEach(lineItem => {
      const payloadFormation = {
        productId: lineItem?.ProductId,
        priceListId: lineItem?.PriceListId,
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        quantity: lineItem?.Quantity,
        amount: lineItem?.Amount,
        amountWithTax: lineItem?.AmountWithTax,
        BasePrice: lineItem?.BasePrice,
        DiscountAmount: lineItem?.DiscountAmount,
        FinalPrice: lineItem?.FinalPrice,
        IsActive: lineItem.IsActive,
        tax: lineItem?.Tax,
        cost: lineItem?.Cost,
        price: lineItem?.Price,
        lineNum: lineItem?.LineNum,
        warrantyProductId: lineItem?.WarrantyProductId,
        WarrantyYears: lineItem?.WarrantyYears,
        qtyOrdered: lineItem?.Quantity,
        qtyDelivered: 0,
        qtyCanceled: 0,
        qtyOutstanding: 0,
        isDirectDelivery: lineItem?.IsDirectDelivery,
        ...(lineItem?.Price < lineItem?.FinalPrice &&
          lineItem?.Cost > lineItem?.Price && {
            NegotiatedPriceBy: lineItem.NegotiatedPriceBy,
            NegotiatedPriceByName: lineItem.NegotiatedPriceByName,
          }),
      }

      const cleanEntries = Object.fromEntries(
        Object.entries(payloadFormation).filter(([_, v]) => v != null)
      )

      arrayOfItems.push(cleanEntries)
    })

    return arrayOfItems
  }

  const generateSaleOrderDocument = async () => {
    let totalTax = 0
    let totalPrice = 0
    let totalCost = 0
    let Quantity = 0
    let cost = 0

    const isCreditCommercial = isCommercialCreditSelected?.credit === 'yes'
    const creditAccountId =
      isCommercialCreditSelected?.accountItemSelected?.CreditAccountId
    const hasValidCreditAccount =
      isCreditCommercial && creditAccountId && creditAccountId !== EMPTY_GUID

    const existingCreditAccountId =
      sellOrderPostData?.Data?.SalesDocumentInfo?.CreditAccountId
    const hasCreditAccountLocked =
      existingCreditAccountId && existingCreditAccountId !== EMPTY_GUID

    if (
      hasCreditAccountLocked &&
      hasValidCreditAccount &&
      creditAccountId !== existingCreditAccountId
    ) {
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.CREDIT_ACCOUNT_LOCKED'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    if (isCreditCommercial && !hasValidCreditAccount) {
      setMessageAddressModal({
        message: t('GENERATE_SALES_ORDER_T.INVALID_CREDIT_ACCOUNT'),
        status: 'error',
      })
      setIsErrorAddressModal(true)
      return
    }

    const someInactiveProds = useSelectorQuoteObject?.QuoteHeader.Lines.some(
      item => item.IsActive === false
    )

    if (someInactiveProds) {
      const reCalculate = useSelectorQuoteObject?.QuoteHeader.Lines.filter(
        prod => prod.IsActive
      )

      reCalculate.forEach(item => {
        totalTax += item.Tax
        totalPrice += item.Price * item.Quantity
        cost = item.Cost || item.AvgCost || 0.0
        totalCost += cost * item.Quantity
        Quantity = parseFloat(Quantity) + parseFloat(item?.Quantity)
      })
    }

    const hasQuote = useSelectorQuoteObject?.QuoteHeader?.DocumentNumber

    const customerId =
      hasQuote && isCountedCustomer
        ? CUSTOMERID
        : isCountedCustomer
        ? CUSTOMERID
        : useSelectorQuoteObject?.QuoteHeader?.CustomerId

    const createSaleOrderPayload = {
      documentTypeId: ID_CONSTANTS.salesOrder.sellOrderTypeID,
      salesOrder: {
        customerId,
        EmailAddress: useSelectorQuoteObject?.QuoteHeader?.EmailAddress,
        ...(isCountedCustomer && {
          Telephone: useSelectorQuoteObject?.QuoteHeader?.Telephone,
        }),
        customerNameDocument:
          useSelectorQuoteObject?.QuoteHeader?.CustomerNameDocument ||
          useSelectorQuoteObject?.QuoteHeader?.CustomerFullName,
        salesAgentId: useSelectorQuoteObject?.QuoteHeader?.SalesAgentId,
        DocumentDate: useSelectorQuoteObject?.QuoteHeader?.DocumentDate,
        quantity: someInactiveProds
          ? Quantity
          : useSelectorQuoteObject?.QuoteHeader?.quantity,
        amount: someInactiveProds
          ? totalPrice
          : useSelectorQuoteObject?.QuoteHeader?.Amount,
        amountWithTax: someInactiveProds
          ? totalPrice + totalTax
          : useSelectorQuoteObject?.QuoteHeader?.AmountWithTax,
        tax: someInactiveProds
          ? totalTax
          : useSelectorQuoteObject?.QuoteHeader?.Tax,
        cost: someInactiveProds
          ? totalCost
          : useSelectorQuoteObject?.QuoteHeader?.Cost,
        companyId: useSelectorQuoteObject?.QuoteHeader?.CompanyId,
        companyCode: useSelectorQuoteObject?.QuoteHeader?.CompanyCode,
        quoteHeaderId: useSelectorQuoteObject?.QuoteHeader?.QuoteHeaderId,
        salesOrderTypeId:
          isCommercialCreditSelected?.credit === 'yes'
            ? salesOrderTypeIds.credito_comercial
            : salesOrderTypeIds.pago_contado,
        HeaderStatusId: ID_CONSTANTS.salesOrder.headerStatusSalesOrderID,
        isDirectDelivery: directdeliveryState ? 1 : 0,
        salesOrderStatusId: ID_CONSTANTS.salesOrder.salesOrderStatusID,
        comments: comment,
        salesAgentEmail: null,
        lines: populateItemsArrayOfPayload(),
        warehouseId: useSelectorQuoteObject?.QuoteHeader?.WarehouseId,
        origin: 'VA',
        CreditAccountId: hasValidCreditAccount ? creditAccountId : null,
        CreditAccountNumber: hasValidCreditAccount
          ? isCommercialCreditSelected?.accountItemSelected?.CreditAccountNumber
          : null,
        OrderNumber: hasValidCreditAccount
          ? sanitizeOrderNumber(isCommercialCreditSelected?.orderNumber)
          : null,
      },
    }
    const result = await dispatch(
      generateSellOrderAction(createSaleOrderPayload)
    )

    if (canChangePriceODV && result.Data) {
      const needsPriceApproval = result.Data.SalesDocumentInfo?.Lines?.some(
        line => line.Price < line.FinalPrice && !line.AuthorizedPriceBy
      )
      if (needsPriceApproval) {
        const variables = {
          saleOrderDocHeaderId: result?.Data?.SalesDocumentInfo?.DocHeaderId,
          saleOrderDocumentNumber:
            result?.Data?.SalesDocumentInfo.DocumentNumber,
          user: user?.AuthenticationInfo,
        }
        await updateProductsAuth(variables)
      }
    }

    if (result.message !== 'ERROR') {
      if (sellOrderFileAttached) {
        await uploadFile({
          file: sellOrderFileAttached,
          docData: result.Data.SalesDocumentInfo,
        })
      }
      dispatch({
        type: 'SET_PREORDER_VALIDATION',
        payload: true,
      })

      dispatch({
        type: 'SET_IS_DIRECT_DELIVERY',
        payload: directdeliveryState,
      })

      dispatch({
        type: 'SET_IS_REDIRECT',
        payload: false,
      })

      dispatch({ type: 'CLEAN_COMMERCIAL_CREDIT_SELECTED' })

      const route = `/orden_de_venta/created/${result.Data.SalesDocumentInfo?.DocHeaderId}`
      history.push(route)
    } else {
      setShowFailedSellOrderState(true)
    }
  }

  useEffect(() => {
    const getOdvDetails = async saleOrderId => {
      try {
        const data = await searchSaleOrderId({
          saleOrderId: sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId,
        })
        data?.Data?.[0] && setWebOdvDetails(data?.Data?.[0])
      } catch (error) {
        console.error('Error:', error)
      }
    }
    if (
      isWebDocument &&
      sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId
    ) {
      getOdvDetails(sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId)
    }
  }, [isWebDocument, sellOrderPostData?.Data?.SalesDocumentInfo?.DocHeaderId])

  const onFailCreatingSellOrderToast = () => {
    return (
      <Modal
        open={showFailedSellOrderState}
        onClose={() => {
          setShowFailedSellOrderState(false)
        }}>
        <Box>
          <GenericModal
            hideCheck={true}
            showCaution={true}
            setConfirm={() => {}}
            setIsOpen={() => setShowFailedSellOrderState(false)}
            text={'No se ha podido crear la orden de venta'}
            mostrarButtons={false}></GenericModal>
        </Box>
      </Modal>
    )
  }

  useEffect(() => {
    const handleStorageChange = event => {
      let documentNumber = null

      let parsedOldValue = null
      try {
        parsedOldValue = event.newValue ? JSON.parse(event.newValue) : null
      } catch (error) {
        console.error('Error parsing JSON:', error, event.newValue)
      }

      documentNumber = parsedOldValue?.documentNumber ?? null

      if (
        event.key === 'updatedQuote' &&
        documentNumber === useSelectorQuoteObject?.QuoteHeader?.DocumentNumber
      ) {
        window.location.reload()
        localStorage.removeItem('updatedQuote')
      } else if (
        event.key === 'createDispatch' &&
        documentNumber ===
          sellOrderPostData?.Data?.SalesDocumentInfo?.DocumentNumber
      ) {
        window.location.reload()
        localStorage.removeItem('createDispatch')
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [useSelectorQuoteObject])

  const isDocumentCanceledOrClosed =
    sellOrderPostData?.Data?.SalesDocumentInfo?.DescriptionStatus ===
    docHeaderStatusDescription.canceled

  const handleSelectAllProducts = selectedValue => {
    const updatedProductList = dispatchQtyState.map(product => {
      if (product.isDisabled) return product

      const originalPendingQty = Number(product.qtyPending)
      const shouldSelectAll = selectedValue === true
      const hasNoDispatchSet = product.solicitud_despacho === ''
      const shouldSetFullDispatch =
        shouldSelectAll && originalPendingQty > 0 && hasNoDispatchSet

      const pendingFormatted = Formatter.Money(
        shouldSetFullDispatch ? 0 : originalPendingQty,
        {
          decimalPrecision: 2,
          ignoreDecimal: !product?.allowFractionalQty,
          withFormat: false,
        }
      )

      return {
        ...product,
        isSelected: selectedValue,
        solicitud_despacho: shouldSetFullDispatch
          ? originalPendingQty
          : product.solicitud_despacho,
        qtyPending: pendingFormatted,
      }
    })

    setDispatchQtyState(updatedProductList)
  }

  return (
    <>
      <Navigation />
      {loadingData ? (
        <MiniLoading full={true} noMargin={true} />
      ) : (
        <>
          {odvStatus ? (
            <Modal open={closeWarningModal}>
              <ContentModalProductNegativeMargin
                setCloseWarningModal={setCloseWarningModal}
              />
            </Modal>
          ) : null}

          <div
            className="sell-order-generada-container"
            data-testid="container-sales-order">
            <div
              className="sell-order-generada"
              style={{ paddingBottom: '16px' }}
              data-testid="container-sales-order-content">
              <div
                className="sell-order-editar-header"
                data-testid="container-sales-order-header">
                <h2 className="titulo-sell-order">
                  {t('SELL_ORDER_T.SELL_ORDER_TITLE')}
                </h2>
              </div>
              <div
                className="sell-order-info-gen"
                data-testid="container-info-general">
                <div
                  className="sell-order-info-gen-cliente"
                  data-testid="container-client-info">
                  {sellOrderValidated &&
                  param?.isPreorderValidatedOnRoute === 'created' ? (
                    <p className="sell-order-info-gen-text">
                      Orden N°:{' '}
                      {
                        sellOrderPostData?.Data?.SalesDocumentInfo
                          ?.DocumentNumber
                      }
                    </p>
                  ) : null}
                  <p className="sell-order-info-gen-text">
                    {`Cliente: ${useSelectorProducts.CustomerNameDocument}`}
                  </p>
                  <p className="sell-order-info-gen-text">
                    {t('SELL_ORDER_T.EMAIL_LABEL', {
                      email:
                        useSelectorProducts?.CustomerEmail ||
                        useSelectorProducts.EmailAddress ||
                        t('SELL_ORDER_T.NO_INFO_LABEL'),
                    })}
                  </p>
                  <p className="sell-order-info-gen-text">
                    {t('SELL_ORDER_T.PHONE_LABEL', {
                      phone:
                        useSelectorProducts.Cellphone_Number ||
                        useSelectorProducts?.Telephone_Number ||
                        t('SELL_ORDER_T.NO_INFO_LABEL'),
                    })}
                  </p>
                  <p className="sell-order-info-gen-text">
                    {t('CREDIT_ACCOUNT', {
                      account:
                        sellOrderPostData?.Data?.SalesDocumentInfo
                          ?.CreditAccountNumber ||
                        isCommercialCreditSelected?.accountItemSelected
                          ?.CreditAccountNumber ||
                        t('SELL_ORDER_T.NO_INFO_LABEL'),
                    })}
                  </p>
                </div>
                <DocumentAddressDetails
                  showHomeDeliveryAddress={showHomeDeliveryAddress}
                  webOdvDetails={webOdvDetails}
                  promisedDate={promisedDate}
                />
                <div
                  className="sell-order-info-gen-vendedor"
                  data-testid="container-seller-info">
                  <p className="sell-order-info-gen-text">
                    {useSelectorProducts?.SalesAgentFullName}
                  </p>
                  <p className="sell-order-info-gen-text">
                    Fecha:{' '}
                    {FormatedDate(
                      sellOrderPostData?.Data?.SalesDocumentInfo?.CreatedDate
                    )}
                  </p>
                  <p className="sell-order-info-gen-text">
                    {t('SELL_ORDER_T.QUOTATION_LABEL', {
                      quotation: useSelectorProducts.DocumentNumber,
                    })}
                  </p>
                  <p className="sell-order-info-gen-text">
                    {t('SELL_ORDER_T.CHANNEL_USED_LABEL', {
                      channel_used: useSelectorProducts.Channel || '',
                    })}
                  </p>
                  <DocumentStatusSelector
                    documentData={sellOrderPostData?.Data?.SalesDocumentInfo}
                    odvStatus={odvStatus}
                    showHomeDeliveryAddress={showHomeDeliveryAddress}
                  />
                </div>
              </div>

              {sellOrderValidated &&
              param?.isPreorderValidatedOnRoute === 'created' ? (
                <div
                  className="sell-order-advice"
                  data-testid="container-warning-message">
                  <p>
                    <span className="info-advice-text-title">
                      {t('SELL_ORDER_T.NOTE_LABEL')}
                    </span>{' '}
                    {t('SELL_ORDER_T.WARNING_TEXT')}
                  </p>
                </div>
              ) : null}

              {sellOrderValidated && preOrderTable && productsActives() ? (
                <div
                  className="sell-order-product-advice"
                  data-testid="container-inactive-product-warning">
                  <p className="info-advice-text">
                    <span className="info-advice-text-title">
                      {t('SELL_ORDER_T.NOTE_LABEL')}:{' '}
                    </span>
                    {t('SELL_ORDER_T.PRESALE_ORDER_ALERT_INACTIVE_PRODUCT', {
                      inactiveProductCode: getInactiveProductCodes(),
                    })}
                  </p>
                </div>
              ) : (
                sellOrderValidated &&
                productsActives() && (
                  <div
                    className="sell-order-product-advice"
                    data-testid="container-dispatch-inactive-warning">
                    <p className="info-advice-text">
                      <span className="info-advice-text-title">
                        {t('SELL_ORDER_T.NOTE_LABEL')}:{' '}
                      </span>
                      {t('SELL_ORDER_T.ALERT_DISPTACH_INACTIVE_PRODUCT', {
                        inactiveProductCode: getInactiveProductCodes(),
                      })}
                    </p>
                  </div>
                )
              )}

              {hasProdWithNoCost ? (
                <div
                  className="sell-order-product-advice"
                  data-testid="container-zero-cost-warning">
                  <p>
                    <span className="info-advice-text-title">Nota: </span>
                    No se puede completar la facturación con productos de costo
                    cero ({getSkusNoCostProduct()}). Por favor, revisa los
                    costos con compras antes de continuar.
                  </p>
                </div>
              ) : null}

              <TableOrdenDeVenta
                data={preOrderTable ? productsData : dispatchQtyState}
                prodWithNoCost={prodWithNoCost}
                columns={columns}
                hideFooter={true}
                isProductPage={false}
                odvProducts={odvProducts}
                isInventory={false}
                setDispatchQtyState={setDispatchQtyState}
                isApproved={isApproved}
                setIsApproved={setIsApproved}
                hiddenColumns={getArrayHiddenColumns(hiddenColumns)}
                hasChangePriceApprove={hasChangePriceApprove}
                selectAllProducts={handleSelectAllProducts}
                changeSelectedStatus={index =>
                  setDispatchQtyState([
                    ...dispatchQtyState.slice(0, index),
                    {
                      ...dispatchQtyState[index],
                      isSelected: !dispatchQtyState[index]?.isSelected,
                    },
                    ...dispatchQtyState.slice(index + 1),
                  ])
                }
                setChangeQty={value => setDispatchQtyState(value)}
                onDeleteProductCallback={value => {
                  setCancelDispatchProductSelected(value)
                  setOpenModalCancelPendingDispatchState(true)
                }}
              />
              <ModifiedBySection />
            </div>

            {!isPreOrder && (
              <PaymentType
                payments={sellOrderPostData?.Data?.SalesDocumentInfo?.Payments}
                totalPayment={
                  sellOrderPostData?.Data?.SalesDocumentInfo?.PaymentTotal ??
                  sellOrderPostData?.Data?.SalesDocumentInfo?.TotalPayment
                }
                statusPayment={
                  sellOrderPostData?.Data?.SalesDocumentInfo?.PaymentStatus ??
                  sellOrderPostData?.Data?.SalesDocumentInfo?.StatusPayment
                }
              />
            )}

            <Container
              className="footer-container"
              data-testid="container-footer">
              <Row className="footer-info">
                <Col data-testid="container-related-documents">
                  <Row className="footer-left-text-title">
                    {t('SELL_ORDER_T.RELATED_DOCS')}
                  </Row>
                  {sellOrderPostData?.Data?.SalesDocumentInfo?.RelationDoc?.map(
                    (item, index) => (
                      <Row className="footer-left-text" key={index}>
                        <RelationalDocLabel
                          value={item}
                          dataODC={dataODC}
                          document={sellOrderPostData?.Data?.SalesDocumentInfo}
                        />
                      </Row>
                    )
                  )}
                </Col>
                <Col data-testid="container-add-comment">
                  <Row className="footer-right-text-title">
                    {t('SELL_ORDER_T.ADD_COMMENTS')}
                  </Row>

                  <Row className="footer-right-row-container">
                    <textarea
                      className="footer-textarea-style"
                      value={comment || ''}
                      maxLength={5000}
                      disabled={isDocumentCanceledOrClosed}
                      onChange={e => setComment(e.target.value)}
                      data-testid="input-comment"
                    />
                  </Row>
                </Col>
              </Row>
            </Container>

            <div
              className="save-button-footer-container"
              data-testid="container-save-button">
              {sellOrderPostLoading ? (
                <button
                  className={'sell-order-save-button-footer'}
                  data-testid="btn-save-loading">
                  <FontAwesomeIcon icon={faSpinner} className="spinner" />
                </button>
              ) : (
                buttonChange &&
                buttonValidator && (
                  <button
                    data-testid="btn-save-sales-order"
                    className={
                      hasProdsActives
                        ? 'sell-order-save-button-footer'
                        : 'sell-order-save-button-footer-inactive'
                    }
                    disabled={
                      !hasProdsActives ||
                      (hasCustomerServiceRol && hasCreditCommercial)
                    }
                    onClick={async () => {
                      if (
                        sellOrderValidated &&
                        param?.isPreorderValidatedOnRoute === 'created'
                      ) {
                        validateOrderInfo()
                      } else {
                        await generateSaleOrderDocument()
                      }
                    }}>
                    {sellOrderValidated &&
                    param?.isPreorderValidatedOnRoute === 'created'
                      ? t('SELL_ORDER_T.GENERATE_DISPATCH_SLOICITUDE')
                      : t('SELL_ORDER_T.CONTINUE_BUTTON')}
                  </button>
                )
              )}
            </div>
          </div>
          {sellOrderValidated &&
          param?.isPreorderValidatedOnRoute === 'created' ? (
            onValidateOrderModals()
          ) : (
            <>
              <>{onFailCreatingSellOrderToast()}</>
            </>
          )}
        </>
      )}
    </>
  )
}

export default OrdenDeVenta
